import { Input } from "antd";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import CustomerSearch from "../../../assets/images/c-serach.svg";
import CustomerIcon from "../../../assets/images/customer1.svg";
import View from "../../../assets/images/view.svg";
import AddUser from "../../../assets/images/userAdd.svg";
import useCartStore from "../../../stores/useCartStore";

const CustomerSearchBar = ({
  tillData,
  cart,
  customerId,
  retailCustomerFields,
  convertMetaDataToKeyValue,
  customerForm,
  autoEnablePanCustomer,
  autoEnableNriBilling,
  setViewCustomerValues,
  setSelectedEditOldCustomer,
  setDisplayEditOldCustomer,
  setDisplayAddNewCustomer,
  setIsViewMode,
  setDisplayCustomerSearch,
  setCloseCustomerFlag,
  showEditOldCustomerFields,
  setEditFlag,
  removeCutomer,
  showAddNewCustomerFields,
}) => {
  return (
    <div data-zone="customer" data-zone-label="Customer" tabIndex={-1} style={{ display: "flex", alignItems: "center" }}>
      {tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId ? (
        <Input
          className="productSearch-sm"
          id="sm-customer-search"
          style={{ borderRadius: "0.5vw", height: "4.9vh", borderColor: "#fff" }}
          placeholder="Enter customer number/name"
          prefix={<img src={CustomerSearch} alt="" style={{ height: "2.7vh" }} />}
          onClick={() => {
            if (cart.isReturn !== true) {
              setDisplayCustomerSearch(true);
              setCloseCustomerFlag(true);
            }
          }}
        />
      ) : (
        <div
          style={{
            padding: "0.7vh 1.3vh",
            border: "none",
            background: "#fff",
            borderRadius: "4px",
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            height: "5vh",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              overflow: "hidden",
              whiteSpace: "nowrap",
              flex: 1,
            }}
          >
            <img
              src={CustomerIcon}
              alt="customer"
              style={{
                width: "20px",
                height: "20px",
                marginRight: "8px",
                flexShrink: 0,
              }}
            />
            <span
              style={{
                fontSize: "0.8rem",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontWeight: "400",
              }}
            >
              {cart?.customer?.name}
              {cart?.customer?.b2cCustomerSegment?.name ? ` - ${cart.customer.b2cCustomerSegment.name}` : ""}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              flexShrink: 0,
              whiteSpace: "nowrap",
            }}
          >
            <img
              src={View}
              style={{
                width: "16px",
                height: "16px",
                cursor: "pointer",
                objectFit: "contain",
              }}
              id="sm-customer-view"
              // onClick={() => { if (cart.isReturn !== true) showEditOldCustomerFields(cart?.customer); }}
              onClick={() => {
                if (cart.isReturn !== true) {
                  if (retailCustomerFields && retailCustomerFields?.length > 0) {
                    const mappedCustomer = convertMetaDataToKeyValue(cart?.customer);
                    const loyaltyBalanceField = retailCustomerFields.find((f) => f.name?.toLowerCase().includes("loyalty balance"));
                    const loyaltyBalance = loyaltyBalanceField?.name ? toCamelCase(loyaltyBalanceField.name) : "";

                    customerForm.setFieldsValue({
                      ...mappedCustomer,
                      mobileno: mappedCustomer?.mobileNo,
                      lastname: mappedCustomer?.lastName,
                      lastvisitdate: mappedCustomer?.lastVisitDate,
                      cardnumber: mappedCustomer?.cardNumber,
                      city: mappedCustomer?.customerAddress?.city,
                      taxID: mappedCustomer?.taxId,
                      anniversaryDate: mappedCustomer?.anniversaryDate?.split(" ")[0],
                      birthday: mappedCustomer?.birthday?.split(" ")[0],
                      validity: mappedCustomer?.validity?.split(" ")[0],
                      loyaltyLevel: mappedCustomer?.loyaltyLevel?.cwrLoyaltyLevelId || null,
                      ...(loyaltyBalance && { [loyaltyBalance]: mappedCustomer?.retlLoyaltyBalance }),
                    });

                    autoEnablePanCustomer(mappedCustomer);
                    autoEnableNriBilling(mappedCustomer);
                    setViewCustomerValues(mappedCustomer);
                    setSelectedEditOldCustomer(cart?.customer);
                    setDisplayEditOldCustomer(true);
                    setDisplayAddNewCustomer(false);
                    setIsViewMode(true);
                  } else {
                    showEditOldCustomerFields(cart?.customer);
                    setIsViewMode(true);
                  }
                }
              }}
            />

            <span style={{ color: "#D9D9D9" }}>|</span>

            <EditOutlined
              style={{
                cursor: "pointer",
                fontSize: "13px",
                color: "#0F0718",
              }}
              id="sm-customer-edit"
              // onClick={() => {
              //   if (cart.isReturn !== true) {
              //     showEditOldCustomerFields(cart?.customer);
              //     setEditFlag(true);
              //   }
              // }}
              onClick={() => {
                if (cart.isReturn !== true) {
                  const cartDetails = useCartStore.getState().cart;

                  if (retailCustomerFields && retailCustomerFields?.length > 0) {
                    const mappedCustomer = convertMetaDataToKeyValue(cartDetails?.customer);
                    const loyaltyBalanceField = retailCustomerFields.find((f) => f.name?.toLowerCase().includes("loyalty balance"));
                    const loyaltyBalance = loyaltyBalanceField?.name ? toCamelCase(loyaltyBalanceField.name) : "";

                    customerForm.setFieldsValue({
                      ...mappedCustomer,
                      mobileno: mappedCustomer?.mobileNo,
                      lastname: mappedCustomer?.lastName,
                      taxID: mappedCustomer?.taxId,
                      lastvisitdate: mappedCustomer?.lastVisitDate,
                      cardnumber: mappedCustomer?.cardNumber,
                      city: (() => {
                        const addr = mappedCustomer?.customerAddress;

                        if (!addr) return "";

                        if (typeof addr === "string") {
                          try {
                            return JSON.parse(addr)?.city || "";
                          } catch (e) {
                            return "";
                          }
                        }

                        return addr.city || "";
                      })(),
                      anniversaryDate: mappedCustomer?.anniversaryDate?.split(" ")[0],
                      birthday: mappedCustomer?.birthday?.split(" ")[0],
                      validity: mappedCustomer?.validity?.split(" ")[0],
                      loyaltyLevel: mappedCustomer?.loyaltyLevel?.cwrLoyaltyLevelId || null,
                      ...(loyaltyBalance && { [loyaltyBalance]: mappedCustomer?.retlLoyaltyBalance }),
                    });

                    autoEnableNriBilling(mappedCustomer);
                    setViewCustomerValues(mappedCustomer);
                    setSelectedEditOldCustomer(cartDetails?.customer);
                    setDisplayEditOldCustomer(true);
                    setDisplayAddNewCustomer(false);
                    setIsViewMode(false);
                    setEditFlag(true);
                  } else {
                    showEditOldCustomerFields(cartDetails?.customer);
                    setIsViewMode(false);
                    setEditFlag(true);
                  }
                }
              }}
            />

            <span style={{ color: "#D9D9D9" }}>|</span>

            <CloseOutlined
              style={{
                fontSize: "13px",
                cursor: "pointer",
                color: "#0F0718",
              }}
              onClick={() => {
                if (cart.isReturn !== true) removeCutomer();
              }}
            />
          </div>
        </div>
      )}
      <img
        src={AddUser}
        style={{ height: "1.6vw", paddingLeft: "0.7vw", cursor: "pointer", alignItems: "center", display: cart?.customer?.cwrCustomerId === customerId ? "" : "none" }}
        onClick={() => {
          if (cart.isReturn !== true) showAddNewCustomerFields(cart.customer);
        }}
      />
    </div>
  );
};

export default CustomerSearchBar;
